export default class EnvironmentTypes {
  static PRODUCTION = "production";

  static STAGING = "staging";
}
